import React, { useState } from "react";
import ReviewsRatingIcon from "../../../../assets/images/svgs/reviewStarSvg.svg";
import cupImage1 from "../../../../assets/images/others/host-side-images/cupImage1.png";
import cupImage2 from "../../../../assets/images/others/host-side-images/cupImage2.png";
import cupImage3 from "../../../../assets/images/others/host-side-images/cupImage3.png";
import cupImage4 from "../../../../assets/images/others/host-side-images/cupImage4.png";
import cupImage5 from "../../../../assets/images/others/host-side-images/cupImage5.png";
import cupImage6 from "../../../../assets/images/others/host-side-images/cupImage6.png";
import useOutsideClick from "../../../../hooks/click-outside";

interface Cups {
  id: number;
  cupImage: string;
  price: string;
  title: string;
  times: string;
}

const cupsData: Cups[] = [
  {
    id: 1,
    cupImage: cupImage1,
    price: "1$",
    title: "Community Roast",
    times: "2 times",
  },
  {
    id: 2,
    cupImage: cupImage2,
    price: "2$",
    title: "Thanks Latte",
    times: "4 times",
  },
  {
    id: 3,
    cupImage: cupImage3,
    price: "3$",
    title: "Curious Cappucccino",
    times: "4 times",
  },
  {
    id: 4,
    cupImage: cupImage4,
    price: "4$",
    title: "Mentors Mocha",
    times: "2 times",
  },
  {
    id: 5,
    cupImage: cupImage5,
    price: "5$",
    title: "Thank you very Matcha",
    times: "4 times",
  },

  {
    id: 6,
    cupImage: cupImage6,
    price: "6$",
    title: "Grateful Grounds",
    times: "5 times",
  },
];

interface ReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ReviewModal: React.FC<ReviewModalProps> = ({ isOpen, onClose }) => {
  const [rating, setRating] = useState<number>(0);
  const [comment, setComment] = useState<string>("");
  const [selectedCup, setSelectedCup] = useState<number | null>(null);
  const modalRef = useOutsideClick(onClose);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed z-50 inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        ref={modalRef}
        className={`bg-white px-6 py-8 rounded-lg shadow-lg w-[85%] h-[80%] md:h-[w-2/3] md:w-2/3 overflow-y-auto transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        <h2 className="text-2xl font-bold text-center mb-4">Add a Review</h2>

        {/* Star Rating */}
        <div className="flex justify-center gap-2 mb-4">
          {[1, 2, 3, 4, 5].map((star) => (
            <img
              key={star}
              src={ReviewsRatingIcon}
              alt="Star"
              className={`w-8 cursor-pointer ${
                star <= rating ? "opacity-100" : "opacity-30"
              }`}
              onClick={() => setRating(star)}
            />
          ))}
        </div>

        {/* Comment Box */}
        <div className="mb-4">
          <label className="block text-gray-700 mb-1">Add comments</label>
          <textarea
            className="w-full border border-gray-300 rounded-md p-3"
            placeholder="Write here"
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>

        {/* Cup Selection */}
        <h3 className="text-lg font-semibold text-center mb-2">
          Select a Cup of Gratitude
        </h3>

        <div className="flex justify-center flex-wrap gap-6">
          {cupsData.map((cup) => (
            <div
              key={cup.id}
              className="relative text-center w-28 flex flex-col items-center h-48 justify-between"
            >
              {/* Cup Image */}
              <div className="relative">
                <img
                  src={cup.cupImage}
                  alt={cup.title}
                  className="w-24 mx-auto"
                />
                {/* Price Badge */}
                <span className="absolute top-[6px] right-2 bg-brown text-[#FFF0D8] text-lg font-bold px-2 py-1 rounded-full">
                  {cup.price}
                </span>
              </div>

              {/* Cup Title */}
              <h3 className="text-blackie text-sm font-bold">{cup.title}</h3>

              {/* Select Button - Aligned at the bottom */}
              <button
                className={`text-xs px-3 py-1 rounded transition ${
                  selectedCup === cup.id
                    ? "bg-yellow-700 text-white"
                    : "bg-yellow-500 text-white"
                }`}
                onClick={() => setSelectedCup(cup.id)}
              >
                {selectedCup === cup.id ? "Selected" : "Select"}
              </button>
            </div>
          ))}
        </div>

        {/* Submit Button */}
        <div
          onClick={() => {
            console.log("Review Submitted:", {
              rating,
              comment,
              selectedCup,
            });
            onClose();
          }}
          className="flex justify-center py-3 rounded-full text-white bg-primaryBlueBg cursor-pointer mt-6 w-1/2 mx-auto"
        >
          <button className="text-center  text-white bg-primaryBlueBg cursor-pointer ">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;
